// Arma el texto a mostrar a partir de los datos crudos de la notificación.
// El backend NO guarda texto: solo `tipo` + `datos`. Acá lo formateamos.

const fmtFecha = new Intl.DateTimeFormat('es-AR', {
  timeZone: 'America/Argentina/Buenos_Aires',
  dateStyle: 'short',
  timeStyle: 'short',
});

function formatearFecha(valor) {
  if (!valor) return '';
  const fecha = new Date(valor);
  return Number.isNaN(fecha.getTime()) ? '' : fmtFecha.format(fecha);
}

/**
 * @param {object} noti notificación cruda del backend ({ tipo, datos, mensaje?, fechaHoraCreacion })
 * @returns {{ titulo: string, descripcion: string, fecha: string }}
 */
export function formatNotificacion(noti) {
  const datos = noti?.datos ?? {};
  const fecha = formatearFecha(noti?.fechaHoraCreacion);

  switch (noti?.tipo) {
    case 'TURNO_RESERVADO':
      return {
        titulo: 'Turno reservado',
        descripcion: `El paciente ${datos.pacienteNombre ?? ''} reservó un turno para el ${formatearFecha(datos.fechaHora)}.`,
        fecha,
      };

    case 'TURNO_CANCELADO':
      return {
        titulo: 'Turno cancelado',
        descripcion: datos.pacienteNombre
          ? `El paciente ${datos.pacienteNombre} canceló el turno del ${formatearFecha(datos.fechaHora)}.`
          : `${datos.medicoNombre ?? 'El médico'} canceló el turno del ${formatearFecha(datos.fechaHora)}.`,
        fecha,
      };

    case 'TURNO_CAMBIO_SOLICITADO':
      return {
        titulo: 'Cambio de fecha solicitado',
        descripcion: datos.pacienteNombre
          ? `El paciente ${datos.pacienteNombre} solicita cambiar el turno del ${formatearFecha(datos.fechaActual)} al ${formatearFecha(datos.fechaPropuesta)}.`
          : `${datos.medicoNombre ?? 'El médico'} solicita cambiar el turno del ${formatearFecha(datos.fechaActual)} al ${formatearFecha(datos.fechaPropuesta)}.`,
        fecha,
      };

    case 'TURNO_CAMBIO_APROBADO':
      return {
        titulo: 'Cambio de fecha aprobado',
        descripcion: `Tu solicitud de cambio para el turno del ${formatearFecha(datos.fechaOriginal)} fue aprobada. Nueva fecha: ${formatearFecha(datos.fechaNueva)}.`,
        fecha,
      };

    case 'TURNO_CAMBIO_RECHAZADO':
      return {
        titulo: 'Cambio de fecha rechazado',
        descripcion: `Tu solicitud de cambio para el turno del ${formatearFecha(datos.fechaOriginal)} fue rechazada.${datos.motivo ? ` Motivo: ${datos.motivo}.` : ''}`,
        fecha,
      };

    case 'TURNO_REALIZADO_PENDIENTE':
      return {
        titulo: 'Turno pendiente de marcar',
        descripcion: `Tenés un turno del ${formatearFecha(datos.fechaHora)}${datos.pacienteNombre ? ` con ${datos.pacienteNombre}` : ''} sin marcar como realizado.`,
        fecha,
      };

    default:
      // Fallback: notificaciones viejas (con texto) o tipos desconocidos.
      return {
        titulo: 'Notificación',
        descripcion: noti?.mensaje ?? 'Tenés una nueva notificación.',
        fecha,
      };
  }
}
